import React, { useEffect, useState } from 'react'
import FavoriteIcon from '@material-ui/icons/Favorite'
import ModalAuth from '../../molecules/modalAuth/modal-auth'
import SessionService from '../../../services/session'
import TalkService from '../../../services/talk'
import { sessionStorage } from '../../../state/utils/storage'
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../utils/userInfo'
import './comments.scss'

const Comments = props => {
	const {
		talkInfo,
		eventInfo,
		prospectRegister = false,
		requireLogin = false,
		defaultProspectEmail,
	} = props

	const [isModalAuth, setIsModalAuth] = useState(false)

	// Comentario
	const [comment, setComment] = useState('')
	// Estado de vaLidacion
	const [isCommentOk, setIsCommentOk] = useState(false)
	const [prospectEmail, setProspectEmail] = useState('')

	const [listComments, setListComments] = useState([])
	const [currentPage, setcurrentPage] = useState(0)

	const [isLoadMore, setIsLoadMore] = useState(false)
	const [forceRender, setForceRender] = useState(false)

	useEffect(() => {
		handleLoadComments()
	}, [])

	useEffect(() => {
		if (comment.length >= 10 && comment.length <= 300) {
			setIsCommentOk(true)
		} else {
			setIsCommentOk(false)
		}
	}, [comment])

	const handleLoadComments = () => {
		setcurrentPage(0)

		const config = {
			headers: {},
		}

		if (
			SessionService.getIdTokenData() &&
			SessionService.getIdTokenData() !== null
		) {
			config.headers.Authorization = SessionService.getIdTokenData()
		}

		const payload = {
			conferenceCmsId: talkInfo.conferenciaId,
			page: 0,
			size: 6,
		}

		TalkService.getComments(payload, config).then(res => {
			if (res.status === 200) {
				setListComments(res.data.data)
				setIsLoadMore(
					res.data?.metadata?.limit > res.data?.metadata?.currentPage + 1
				)
			} else {
				console.warn(res.userMessage)
			}
		})
	}

	const handleLoadMoreComments = () => {
		const copyCurrentPage = currentPage
		const copyComments = listComments

		setcurrentPage(copyCurrentPage + 1)

		const config = {
			headers: {},
		}

		if (
			SessionService.getIdTokenData() &&
			SessionService.getIdTokenData() !== null
		) {
			config.headers.Authorization = SessionService.getIdTokenData()
		}

		const payload = {
			conferenceCmsId: talkInfo.conferenciaId,
			page: copyCurrentPage + 1,
			size: 6,
		}

		TalkService.getComments(payload, config).then(res => {
			if (res.status === 200) {
				setListComments([...copyComments, ...res.data.data])
				setIsLoadMore(
					res.data?.metadata?.limit > res.data?.metadata.currentPage + 1
				)
			} else {
				console.warn(res.data.userMessage)
			}
		})
	}

	const handleLike = (commentId, likeState) => {
		if (
			!SessionService.getUserData() &&
			requireLogin &&
			!defaultProspectEmail &&
			prospectEmail === ''
		) {
			setIsModalAuth(true)
			return false
		}

		const copyLocalLikes = listComments

		const config = {
			headers: {},
		}

		if (
			SessionService.getIdTokenData() &&
			SessionService.getIdTokenData() !== null
		) {
			config.headers.Authorization = SessionService.getIdTokenData()
		}

		const payload = {
			commentId,
			like: likeState,
			email: defaultProspectEmail || prospectEmail,
		}

		TalkService.setLikeComment(payload, config).then(res => {
			if (res.status === 200) {
				const index = copyLocalLikes.findIndex(
					c => c.conferenceCommentId === commentId
				)
				if (index !== null) {
					copyLocalLikes[index] = {
						...copyLocalLikes[index],
						conferenceCommentId: commentId,
						like: likeState,
						totalLikes:
							copyLocalLikes[index].totalLikes === null
								? 1
								: likeState === true
									? copyLocalLikes[index].totalLikes + 1
									: copyLocalLikes[index].totalLikes - 1,
					}
					setListComments(copyLocalLikes)
					setForceRender(!forceRender)
				}
			} else {
				console.warn(res.userMessage)
			}
		})
	}

	const getInitials = name => {
		const arrayaName = name.split(' ')
		return (
			arrayaName[0].charAt(0).toUpperCase() +
			arrayaName[1].charAt(0).toUpperCase()
		)
	}

	const handleSubmit = e => {
		dataLaterLike(
			'Comentar',
			'Interacciones - Comentarios',
			'acomentarios',
			'click'
		)
		e.preventDefault()
		if (isCommentOk) {
			let payload = {
				commentDetail: comment,
				conferenceCmsId: talkInfo.conferenciaId,
				event: eventInfo?.identificadorEvento,
			}

			let config = {}

			// if have prospect email add param for endpoint else add autorizathion token
			if (prospectEmail !== '' || defaultProspectEmail) {
				payload = {
					...payload,
					email: defaultProspectEmail || prospectEmail,
				}
			} else {
				config = {
					headers: {
						Authorization: SessionService.getIdTokenData(),
					},
				}
			}

			TalkService.saveConsulting(payload, config).then(res => {
				console.log('enviado')

				if (res.status === 200) {
					setComment('')
					handleLoadComments()
				} else {
					console.warn(res.userMessage)
				}
			})
		}
	}

	const formatNumber = num => {
		if (num > 999999) {
			return parseInt(num / 1000000, 10).toString() + 'M'
		} else if (num > 999) {
			return parseInt(num / 1000, 10).toString() + 'K'
		} else {
			return num
		}
	}

	const handleRedirection = () => {
		setIsModalAuth(false)
	}

	const userInf = dataLayerUserInfo()
	const dataLaterLike = (label, event, cat, action) => {
		let location = ''
		if (typeof window !== 'undefined') {
			location = window.location.href
		}
		pushDataLayerEvent({
			event: event,
			category: cat,
			action: action,
			label: label,
			article_name: eventInfo.nombreDelEvento,
			sub_category: eventInfo.categoria[0]
				? eventInfo.categoria[0].nombreDeEtiqueta
				: 'ninguno',
			location: location,
			user_data: userInf.user_data ? userInf.user_data : '',
			log_status: userInf.log_status,
		})
	}
	return (
		<section className='f-comments-talk'>
			<h2 className='f-comments-talk-title'>Comentarios</h2>

			<div className='f-comments-talk__wrapper'>
				<div className='f-comments-talk__comment'>
					<form onSubmit={handleSubmit}>
						<textarea
							value={comment}
							onClick={() => {
								if (
									!SessionService.getUserData() &&
									requireLogin &&
									prospectEmail === '' &&
									!defaultProspectEmail
								) {
									setIsModalAuth(true)
									return false
								}
							}}
							onChange={e => {
								if (
									!SessionService.getUserData() &&
									requireLogin &&
									prospectEmail === '' &&
									!defaultProspectEmail
								) {
									setIsModalAuth(true)
									return false
								}

								setComment(
									e.target.value
										.replace(
											/[^a-zA-ZáéíóúÁÉÍÓÚ1234567890ñ""!¡?¿,.;:()/-_+%# ]/g,
											''
										)
										.replace(/ {2}/g, ' ')
										.slice(0, 300)
								)
							}}
							className='f-comments-talk__comment-input'
							placeholder='Escribe un comentario'
						/>
						<div className='f-comments-talk__comment-btn'>
							<button className={`${isCommentOk ? '' : 'invalid'} `}>
								Comentar
							</button>
						</div>
					</form>
				</div>

				<div className='f-comments-talk__comments'>
					{listComments &&
						listComments.map((item, index) => {
							return (
								<div
									key={`comment-${index}`}
									className='f-comments-talk__comment-users'
								>
									<div className='f-comments-talk__comment-users-initials'>
										<div className='f-comments-talk__comment-users-initials-content'>
											{getInitials(item.user)}
										</div>
									</div>
									<div className='f-comments-talk__comment-users-body'>
										<h4>{item.user}</h4>
										<p>{item.comment}</p>
									</div>
									<div
										className={`f-comments-talk__comment-users-likes ${listComments[index].like ? 'like' : ''
											}`}
									>
										<p
											onClick={() => {
												dataLaterLike(
													'Me gusta',
													'Interacciones - Articulos',
													'academia tena',
													'click'
												)
												handleLike(
													item.conferenceCommentId,
													!listComments[index].like
												)
											}}
										>
											Me gusta <FavoriteIcon />{' '}
											{listComments[index].totalLikes !== null &&
												listComments[index].totalLikes !== 0 &&
												formatNumber(listComments[index].totalLikes)}
										</p>
									</div>
								</div>
							)
						})}
				</div>

				{isLoadMore && (
					<div className='f-comments-talk__load-more'>
						<button onClick={() => handleLoadMoreComments()}>Cargar más</button>
					</div>
				)}
			</div>

			{isModalAuth && (
				<ModalAuth
					hideAction={() => {
						handleRedirection()
					}}
					validateCoverage={() => false}
					showModalCoverage={() => {
						handleRedirection()
					}}
					setProspectEmail={setProspectEmail}
					buttonProspect={props.buttonProspect}
					onSuccessProspectRegister={data => {
						sessionStorage.setItem('PROSPECT_TEMP_USER', data)
						setProspectEmail(data.email)
						setIsModalAuth(false)
					}}
					isComment={true}
					isWebinar
					prospectRegister={prospectRegister}
					title={
						<>
							Para acceder al contenido de <span>TENA,</span> debes ingresar a
							tu cuenta o registrarte.
						</>
					}
				/>
			)}
		</section>
	)
}

export default Comments
